exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-3b42a218]{text-align:center}.ant-popover-inner-content p[data-v-3b42a218]{margin-bottom:0}", ""]);

// exports
